"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pageConfigApi = _interopRequireWildcard(require("@/api/productPageConfig"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者,助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件,未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default2 = exports.default = {
  name: 'EditPageConfig',
  components: {
    Tinymce: _Tinymce.default
  },
  props: {
    editData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      loadingFrom: false,
      rules: {
        productCode: [{
          required: true,
          message: '请输入产品编号',
          trigger: 'blur'
        }, {
          max: 64,
          message: '产品编号不能超过64个字符',
          trigger: 'blur'
        }],
        pageName: [{
          required: true,
          message: '请输入页面名称',
          trigger: 'blur'
        }, {
          max: 128,
          message: '页面名称不能超过128个字符',
          trigger: 'blur'
        }],
        submitButtonText: [{
          max: 32,
          message: '提交按钮文案不能超过32个字符',
          trigger: 'blur'
        }]
      },
      dataForm: {
        id: null,
        productCode: '',
        pageName: '',
        headerImage: '',
        backgroundColor: '',
        productDesc: '',
        submitButtonText: '立即订购',
        enablePrivacy: false,
        privacyContent: '',
        enableSecondConfirm: false,
        secondConfirmContent: '',
        enableSuccessPopup: false,
        successPopupContent: '',
        status: true,
        sort: 0
      }
    };
  },
  watch: {
    editData: {
      handler: function handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.dataForm = {
            id: val.id || null,
            productCode: val.productCode || '',
            pageName: val.pageName || '',
            headerImage: val.headerImage || '',
            backgroundColor: val.backgroundColor || '',
            productDesc: val.productDesc || '',
            submitButtonText: val.submitButtonText || '立即订购',
            enablePrivacy: val.enablePrivacy || false,
            privacyContent: val.privacyContent || '',
            enableSecondConfirm: val.enableSecondConfirm || false,
            secondConfirmContent: val.secondConfirmContent || '',
            enableSuccessPopup: val.enableSuccessPopup || false,
            successPopupContent: val.successPopupContent || '',
            status: val.status !== undefined ? val.status : true,
            sort: val.sort || 0
          };
        } else {
          this.resetDataForm();
        }
      },
      deep: true
    }
  },
  methods: {
    // 点击上传图片
    modalPicTap: function modalPicTap() {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        _this.dataForm.headerImage = img[0].sattDir;
      }, false, 'product');
    },
    // 关闭弹窗
    handleClose: function handleClose() {
      var _this2 = this;
      this.$refs['dataForm'].resetFields();
      this.resetDataForm();
      this.$nextTick(function () {
        _this2.dialogVisible = false;
      });
    },
    // 重置表单数据
    resetDataForm: function resetDataForm() {
      this.dataForm = {
        id: null,
        productCode: '',
        pageName: '',
        headerImage: '',
        backgroundColor: '',
        productDesc: '',
        submitButtonText: '立即订购',
        enablePrivacy: false,
        privacyContent: '',
        enableSecondConfirm: false,
        secondConfirmContent: '',
        enableSuccessPopup: false,
        successPopupContent: '',
        status: true,
        sort: 0
      };
    },
    // 颜色变化处理(转换为HEX格式)
    handleColorChange: function handleColorChange(value) {
      if (!value) {
        this.dataForm.backgroundColor = '';
      }
    },
    // 重置背景颜色
    resetBackgroundColor: function resetBackgroundColor() {
      this.dataForm.backgroundColor = '';
    },
    // 提交表单
    onSubmit: function onSubmit(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var submitData = _objectSpread({}, _this3.dataForm);

          // 如果未启用相关功能,清空对应内容
          if (!submitData.enablePrivacy) {
            submitData.privacyContent = '';
          }
          if (!submitData.enableSecondConfirm) {
            submitData.secondConfirmContent = '';
          }
          if (!submitData.enableSuccessPopup) {
            submitData.successPopupContent = '';
          }
          var apiMethod = submitData.id ? pageConfigApi.pageConfigUpdateApi : pageConfigApi.pageConfigSaveApi;
          apiMethod(submitData).then(function () {
            _this3.$message.success(submitData.id ? '编辑成功' : '新增成功');
            _this3.handleClose();
            _this3.loading = false;
            _this3.$emit('getList');
          }).catch(function () {
            _this3.loading = false;
          });
        } else {
          return false;
        }
      });
    }
  }
};